<template>
  <InfuseButton
    :id="`btn-login-${policy}`"
    :class="`azure-b2c-auth-button azure-b2c-auth-button--${buttonColor()}`"
    :size="size"
    :color="buttonColor()"
    :disabled="disabled"
    font-weight="medium"
    font-size="sm"
    @click="onClick($event)"
  >
    <span class="inline-flex items-center gap-2 leading-none">
      <span>{{ policyName(policy) }}</span>
      <img
        v-if="!getCustomizedPolicy()"
        src="/favicon.ico"
        alt=""
        class="inline-block h-4 w-4 object-contain align-middle"
      />
    </span>
  </InfuseButton>
</template>

<script setup lang="ts">
import { AzureB2CAuthenticator, useAuthenticator } from '@infuse/auth/services';
import { InfuseButton } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const authenticator = useAuthenticator();
const emit = defineEmits(['click']);

const azureB2CPoliciesWithCustomizedButtons = [
  { key: 'B2C_1_signup_signin_infuse_employees', button: 'neutral' },
  { key: 'B2C_1_signup_signin_infuse_customers', button: 'primary' }
];

function getCustomizedPolicy() {
  return azureB2CPoliciesWithCustomizedButtons.find((i) => i.key === props.policy);
}

function buttonColor() {
  return getCustomizedPolicy()?.button || 'primary';
}

function policyName(policy: string): string {
  if (getCustomizedPolicy()) {
    return t(`auth.signIn.${policy}`);
  } else {
    return t('auth.signIn.withAzureB2c', { policy: formatPolicyName(policy) });
  }
}

function formatPolicyName(policy: string): string {
  // Use the instance method to get configured display name, falling back to auto-generated
  if (authenticator instanceof AzureB2CAuthenticator) {
    return authenticator.getPolicyDisplayName(policy);
  }
  return policy;
}

interface Props {
  policy: string;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large'
});

function onClick(event: Event) {
  emit('click', event);
}
</script>
